import { render, staticRenderFns } from "./FinancesDetailes.vue?vue&type=template&id=fae8a882&scoped=true&"
import script from "./FinancesDetailes.vue?vue&type=script&lang=js&"
export * from "./FinancesDetailes.vue?vue&type=script&lang=js&"
import style0 from "./FinancesDetailes.vue?vue&type=style&index=0&id=fae8a882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae8a882",
  null
  
)

export default component.exports